import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import MobileHeader from 'swag-client-common/components/info/mobile-header';
import { shareProductDispatcher } from '../../../redux/product/product.dispatchers';
import classes from './share-product-popup.scss';
class ShareProductPopup extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isCopied: false,
      email: ''
    };
    this.handleCopy = this.handleCopy.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleCopy() {
    this.setState({
      isCopied: true
    });
    this.props.onLinkCopy();
  }
  handleChange(e) {
    this.setState({
      email: e.currentTarget.value
    });
  }
  renderContent() {
    const {
      onClose,
      onSendEmail
    } = this.props;
    const {
      isCopied,
      email
    } = this.state;
    const isValid = email.length > 7;
    const currentLocationLink = document.location.href;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.innerContainer
    }, /*#__PURE__*/React.createElement(MobileHeader, {
      headerText: "Share",
      onClose: onClose
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.content
    }, /*#__PURE__*/React.createElement("h1", {
      className: classes.section
    }, "Want to share product?"), /*#__PURE__*/React.createElement("div", {
      className: classes.section
    }, /*#__PURE__*/React.createElement("input", {
      className: classes.input,
      type: "text",
      onChange: this.handleChange,
      value: email,
      placeholder: "Input email address"
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.section
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.blackTextBorderedButton, classes.button, {
        [classes.disabled]: !isValid
      }),
      onClick: () => onSendEmail({
        link: currentLocationLink,
        email
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.icon, classes.email, {
        [classes.emailDisabled]: !isValid
      })
    }), /*#__PURE__*/React.createElement("span", null, "Send Email"))), /*#__PURE__*/React.createElement("div", {
      className: classes.section
    }, /*#__PURE__*/React.createElement(CopyToClipboard, {
      onCopy: this.handleCopy,
      text: currentLocationLink
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.blackTextBorderedButton, classes.button)
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.icon, classes.link)
    }), /*#__PURE__*/React.createElement("span", null, isCopied ? 'Copied' : 'Copy link')))))));
  }
  render() {
    return /*#__PURE__*/React.createElement(InfoDialog, {
      content: this.renderContent(),
      showCloseButton: false,
      className: classes.dialogClass,
      open: true
    });
  }
}
export default connect(null, shareProductDispatcher)(ShareProductPopup);